import _extends from "@babel/runtime/helpers/extends";
import React from "react";
import { IntlProvider } from "react-intl";
import messages from "./i18n/it_IT.json";
export function getProductSuffix() {
  return ".html";
}
export function getCategorySuffix() {
  return ".html";
}
var LocaleProvider = props => {
  var locale = "it-IT";
  var onIntlError = error => {
    if (messages) {
      if (error.code === "MISSING_TRANSLATION") {
        console.warn("Missing translation", error.message);
        return;
      }
      throw error;
    }
  };
  return /*#__PURE__*/React.createElement(IntlProvider, _extends({
    key: locale
  }, props, {
    defaultLocale: "it-IT",
    locale: locale,
    messages: messages,
    onError: onIntlError
  }));
};
export default LocaleProvider;